import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { AvatarVoicePreset } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface PresetsData {
  voice_presets: AvatarVoicePreset[]
}

export const fetchAvatarVoicePresets = async (workspaceId: number, brandKitId: number) => {
  const res = await sendToApi<PresetsData>(`/w/${workspaceId}/brand_kits/${brandKitId}/avatars/voice_presets`)
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Failed to fetch voice presets')
  }
  return res.data
}

export const useAvatarVoicePresets = (
  { brandKitId }: { brandKitId?: number },
  options?: UseQueryOptions<AvatarVoicePreset[]>,
) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<AvatarVoicePreset[]>(
    ['workspaces', workspaceId, 'brandKits', brandKitId, 'avatars', 'voicePresets'],
    async () => {
      if (!brandKitId) throw new Error('brandKitId is required')
      const data = await fetchAvatarVoicePresets(workspaceId, brandKitId)
      return data?.voice_presets ?? []
    },
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: !!brandKitId,
      ...options,
    },
  )
}
